import { asyncActionsCreator, createActionRedux } from '../../global/redux';
import * as constants from './constants';

export const getCurrentReceipt = asyncActionsCreator(
  constants.GET_CURRENT_RECEIPT
);

export const setChosenReceipt = asyncActionsCreator(
  constants.SET_CHOSEN_RECEIPT
);

export const getClientInfo = asyncActionsCreator(constants.GET_CLIENT_INFO);

export const getPharmacistTodayBonuses = asyncActionsCreator(
  constants.GET_PHARMACIST_TODAY_BONUSES
);

export const getClientOrders = asyncActionsCreator(constants.GET_CLIENT_ORDERS);

export const applyBonuses = asyncActionsCreator(constants.APPLY_BONUSES);
export const submitLoyaltyOrder = asyncActionsCreator(
  constants.SUBMIT_LOYALTY_ORDER
);
export const setPartnerPaymentMethod = asyncActionsCreator(
  constants.SET_PARTNER_PAYMENT_METHOD
);
export const setInPlacePaymentMethod = asyncActionsCreator(
  constants.SET_IN_PLACE_PAYMENT_METHOD
);

export const getPartnerPayments = asyncActionsCreator(
  constants.GET_PARTNER_PAYMENTS
);

export const sendToStandart = asyncActionsCreator(constants.SEND_TO_STANDARD);
export const getHealthStatus = asyncActionsCreator(constants.GET_HEALTH_STATUS);

export const resetClientInfo = createActionRedux(constants.RESET_CLIENT_INFO);
export const resetCurrentReceipt = createActionRedux(
  constants.RESET_CURRENT_RECEIPT
);
export const resetApplyBonuses = createActionRedux(
  constants.RESET_APPLY_BONUSES
);
export const resetSubmitOrder = createActionRedux(constants.RESET_SUBMIT_ORDER);

export const generateLoyaltyReport = asyncActionsCreator(
  constants.GENERATE_LOYALTY_REPORT
);

export const addLoyaltyProduct = asyncActionsCreator(
  constants.ADD_LOYALTY_PRODUCT
);
export const getLoyaltyProducts = asyncActionsCreator(
  constants.GET_LOYALTY_PRODUCTS
);
export const deleteLoyaltyProduct = asyncActionsCreator(
  constants.DELETE_LOYALTY_PRODUCT
);

export const getLoyaltyPercentages = asyncActionsCreator(
  constants.GET_LOYALTY_PERCENTAGES
);

export const creditBonuses = asyncActionsCreator(constants.CREDIT_BONUSES);
export const getRecommendations = asyncActionsCreator(
  constants.GET_RECOMMENDATIONS
);

export const setLoyaltyInfoBot = asyncActionsCreator(
  constants.SET_LOYALTY_INFO_BOT
);
